import { gql } from '@apollo/client'

export const UPDATE_CASE_EMAIL_VISIBILITY_MUTATION = gql`
  mutation UpdateCaseEmailVisibility($emailId: ID!, $visibleForOtherProcessings: Boolean!) {
    updateCaseEmailVisibility(
      emailId: $emailId
      visibleForOtherProcessings: $visibleForOtherProcessings
    ) {
      caseEmail {
        id
        visibleForOtherProcessings
      }
      errors
    }
  }
`
